import { Trans } from "@lingui/macro";
import {
  IUiDialogResponsiveProps,
  UiBox,
  UiGrid,
  UiLink,
  UiTable,
  UiTypography,
} from "@smp/ui";

import { HelperAdapterLink } from "@/components/helpers/helper_adapter_link";
import { useEpPageconfigListRecursive } from "@/hooks/use_ep_pageconfig";

import { Page } from "./page";
import classes from "./pages.module.css";
import { PostLast } from "./post_last";
import { Posts } from "./posts";

export const Pages = ({
  onClose,
}: {
  onClose: IUiDialogResponsiveProps["onClose"];
}) => {
  const { pageconfigList } = useEpPageconfigListRecursive({
    req: {
      query: { has_scheduled_posts: true },
    },
    useQueryOptions: {
      refetchOnMount: "always",
    },
  });

  if (!pageconfigList) return null;

  const handleClickPosting = () => {
    onClose && onClose({}, "backdropClick");
  };

  return (
    <UiGrid item xs={12} className={classes.wrapper}>
      {pageconfigList.length ? (
        <UiTable
          columns={[
            {
              Cell: (pageconfig) => (
                <Page
                  externalId={pageconfig.external_id}
                  medium={pageconfig.medium}
                />
              ),
              title: <Trans>Page</Trans>,
            },
            {
              Cell: (pageconfig) => <Posts pageconfig={pageconfig} />,
              align: "center",
              title: <Trans>Posts</Trans>,
            },
            {
              Cell: (pageconfig) => (
                <PostLast lookFor="first" pageconfig={pageconfig} />
              ),
              align: "center",
              title: <Trans>First</Trans>,
            },
            {
              Cell: (pageconfig) => (
                <PostLast lookFor="last" pageconfig={pageconfig} />
              ),
              align: "center",
              title: <Trans>Last</Trans>,
            },
          ]}
          items={pageconfigList}
          pageSize={5}
        />
      ) : (
        <UiBox display="flex" justifyContent="center">
          <UiTypography>
            <Trans>
              Nothing has been planned yet. To start, go to{" "}
              <UiLink
                component={HelperAdapterLink}
                onClick={handleClickPosting}
                to="/posts"
              >
                Posting
              </UiLink>
            </Trans>
          </UiTypography>
        </UiBox>
      )}
    </UiGrid>
  );
};
